import {useLocalSearchParams} from "expo-router";
import {MembershipProfile} from "@/components/profile/MembershipProfile";

export default function Profile() {
    const {orgId} = useLocalSearchParams<{orgId: string}>();
    return (
        <MembershipProfile orgId={orgId} />
    );
}
